import { RegistrationApiResponse } from '@/components/addons/registration/types';
import { FormDisableDefaultBehavior } from '@/exceptions/FormDisableDefaultBehavior';
import { events } from '@/services/events';
import { SectionModelType } from '@/typings/types/types';

interface EventData {
  pageModel: SectionModelType;
  response: RegistrationApiResponse;
}

export class FormSubmitResponseEvent extends CustomEvent<EventData> {
  public static async emit(
    pageModel: SectionModelType,
    response: RegistrationApiResponse
  ): Promise<FormSubmitResponseEvent> {
    const event = new FormSubmitResponseEvent('formSubmitResponse', {
      detail: {
        pageModel,
        response
      },
      cancelable: true
    });

    events.emit('formSubmitResponse', event);
    if (event.defaultPrevented) {
      throw new FormDisableDefaultBehavior(
        'Prevent default behavior for form submit, was prevented in formSubmitResponse SDK event'
      );
    }

    return event;
  }
}
